import React from 'react';
import { BrowserRouter,Route, Switch} from 'react-router-dom';
import Poptire from './Poptire';
import Home from './Home';
import Share from './Share';
class Routes extends React.Component {
    render(){
        return(
            <BrowserRouter basename="/assurance-maxguard-suv">
            <Switch>
                <Route exact  path="/" component={Home}/>
                <Route exact  path="/pumptire" component={Poptire}/>
                <Route exact  path="/Share" component={Share}/>
            </Switch>
            </BrowserRouter>
        )
    }
}
export default Routes